exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1pxEa-stHFidL4i91pVuR5{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"TriggerUpsellModal": "_1pxEa-stHFidL4i91pVuR5"
};